module.exports = __webpack_public_path__ + "img/ico-admins--black.67d97305.svg";